import { render, staticRenderFns } from "./NewClientPage.vue?vue&type=template&id=d213fd52&scoped=true"
import script from "./NewClientPage.vue?vue&type=script&lang=js"
export * from "./NewClientPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d213fd52",
  null
  
)

export default component.exports